<template>
  <div class="pm-dialog-weather">
    <div class="flex justify-center outer-area">
      <div class="vs-col candidate-list" v-for="(master,index) in masterList" :key="index" @mousedown="updateSelectedIds(master.id)">

        <vs-chip 
          :color="(selectedIds.includes(master.id)) ? '#346c88' : '#828282' "
        >
          <feather-icon v-if="master.id === '1'"  icon="WindIcon"      svgClasses="h-6 w-6" class="mr-2" />
          <img v-if="master.id === '2'" :src="rainWhiteIcon" class="mr-2 h-6 w-6" />
          <img v-if="master.id === '3'" :src="snowWhiteIcon" class="mr-2 h-6 w-6" />
        </vs-chip>
      </div>
    </div>

    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
      >
        保存
      </vs-button>
      <vs-button
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
      selectedIds: [],
      snowDarkIcon: require(`@/assets/images/icons/port-master/snow_dark.svg`),
      snowWhiteIcon: require(`@/assets/images/icons/port-master/snow_white.svg`),
      rainDarkIcon: require(`@/assets/images/icons/port-master/rain_dark.svg`),
      rainWhiteIcon: require(`@/assets/images/icons/port-master/rain_white.svg`),
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return this.masterMap['weather'];
    },
    enableSave() {
      return true; // ( this.selectedIds && this.selectedIds.length > 0 );
    },
  },
  methods: {
    initData() {
      if ( this.valueMap ) {
        this.selectedIds = [this.valueMap.id];
      }
    },
    updateSelectedIds(masterId) {
      if (this.selectedIds.includes(masterId)) {
        this.selectedIds = [] ;
      } else if ( this.selectedIds.length > 0 ) {
        this.selectedIds = [] ;
        this.selectedIds.push(masterId);
      } else {
        this.selectedIds.push(masterId);
      }
    },
    onSubmit(isUpdateTimeStamp) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey + '#id'] = this.selectedIds.length > 0 ? this.selectedIds[0] : "";
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-weather {
  .outer-area {
    padding: 1rem;
  }
  .candidate-list {
    margin: 0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 4rem;
      padding-left: 0.4rem;
    }
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }
}
</style>

